<template>
  <div class="app-subscription-order" v-loading="dataLoading">

    <!-- 筛选栏 -->
    <div class="toolbar">
      <div class="filter-container">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          size="small"
          range-separator="~"
          start-placeholder="Start date"
          end-placeholder="End date"
          value-format="timestamp"
          style="width: 240px; margin-right: 15px;"
          @change="handleSearch"
        />
        <div class="search-bar">
          <el-input size="small" v-model="listQuery.q" placeholder="Nickname / Phone No" @keyup.enter.native="handleSearch">
            <el-select v-model="listQuery.queryType" slot="prepend">
              <el-option label="User" value="user"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>
        </div>
      </div>
    </div>

    <!-- 订单表格 -->
    <el-table :data="tableData" row-key="id" >
      <el-table-column prop="id" label="ID" width="65" />
      <el-table-column prop="nickname" label="Nickname" min-width="120" />
      <el-table-column prop="phoneNo" label="Phone No" min-width="130" />
      <el-table-column prop="planName" label="Plan Name" min-width="120" />
      <el-table-column label="Out Trade No" min-width="230">
        <template slot-scope="scope">
          <span class="trade-no">{{ scope.row.outTradeNo }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="targetLevel" label="Level" width="90" />
      <el-table-column label="Price (¥)" width="95" align="right">
        <template slot-scope="scope">
          {{ (scope.row.priceCents / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column label="Channel" width="120">
        <template slot-scope="scope">
          <el-tag size="mini" :type="channelTagType(scope.row.payChannel)">
            {{ scope.row.payChannel }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Status" width="95" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="statusTagType(scope.row.status)">
            {{ scope.row.status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Env" width="55" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.env === 0 ? 'Prod' : 'Dev' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Paid At" min-width="170">
        <template slot-scope="scope">
          <span v-if="scope.row.paidAt">
            <i class="el-icon-time" />
            <span style="margin-left: 6px">{{ scope.row.paidAt | displayTime() }}</span>
          </span>
          <span v-else class="text-muted">—</span>
        </template>
      </el-table-column>
      <el-table-column label="Created At" min-width="170">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span style="margin-left: 6px">{{ scope.row.createdAt | displayTime() }}</span>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :offset.sync="listQuery.offset"
      :limit.sync="listQuery.limit"
      layout="sizes, prev, pager, next, total"
      @pagination="fetchData"
    />
  </div>
</template>

<script>
import { fetchAppSubscriptionOrders } from "@/api/admin";
import Pagination from "@/components/Pagination";

export default {
  name: "AppTabSubscriptionOrder",
  components: { Pagination },
  data() {
    return {
      tableData: [],
      total: 0,
      dataLoading: false,
      dateRange: null,
      listQuery: {
        q: "",
        queryType: "user",
        startTime: undefined,
        endTime: undefined,
        offset: 0,
        limit: 10,
      },
    };
  },
  mounted() {
    this.active();
  },
  methods: {
    active() {
      this.fetchData();
    },
    fetchData() {
      this.dataLoading = true;
      const params = { ...this.listQuery };
      // 去掉空值，避免传 undefined 给后端
      if (!params.q) delete params.q;
      if (!params.startTime) delete params.startTime;
      if (!params.endTime) delete params.endTime;

      fetchAppSubscriptionOrders(params)
        .then((response) => {
          if (response.success) {
            this.tableData = response.result.items || [];
            this.total = response.result.totalCount;
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    handleSearch() {
      this.listQuery.offset = 0;
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.startTime = this.dateRange[0];
        // endTime 取当天结束（23:59:59.999）
        this.listQuery.endTime = this.dateRange[1] + 86400000 - 1;
      } else {
        this.listQuery.startTime = undefined;
        this.listQuery.endTime = undefined;
      }
      this.fetchData();
    },
    handleReset() {
      this.dateRange = null;
      this.listQuery = {
        q: "",
        queryType: "user",
        startTime: undefined,
        endTime: undefined,
        offset: 0,
        limit: 10,
      };
      this.fetchData();
    },
    statusTagType(status) {
      const map = {
        delivered: "success",
        paid: "primary",
        pending: "warning",
        refunded: "info",
        failed: "danger",
      };
      return map[status] || "";
    },
    channelTagType(channel) {
      if (!channel) return "";
      if (channel.startsWith("wx")) return "success";
      if (channel.startsWith("alipay")) return "primary";
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.app-subscription-order {
  .toolbar {
    margin-bottom: 12px;
    text-align: right;

    .filter-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .search-bar {
      display: inline-block;

      ::v-deep .el-select .el-input {
        width: 100px;
      }

      .el-input {
        width: 350px;
      }
    }
  }

  .trade-no {
    font-size: 12px;
    font-family: monospace;
    color: #606266;
  }

  .text-muted {
    color: #c0c4cc;
  }
}
</style>
